import React, { useEffect, useState } from 'react';
import { Embed } from '../../interfaces/article';
import Strapi from '../../services/strapi';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { TextField, Button } from '@material-ui/core';
import StrapiEmbedPopup from './StrapiEmbedPopup';

interface StrapiEmbedProps {
	value: Embed,
	onChange: (value: Embed) => void,
}

const StrapiEmbed = (props: StrapiEmbedProps) => {
	const [options, setOptions] = useState<any[]>([]);
	const [inputValue, setInputValue] = useState<string>("");
	const [open, setOpen] = useState<boolean>(false);

	useEffect(() => {
		const params: any = {
			_limit: 10,
			title_contains: inputValue
		};

		Strapi.get("embeds", params, {}).then((r) => {
			setOptions(r);
		});
		return () => {
		}
	}, [inputValue])

	return <>
		<Autocomplete
			value={props.value}
			options={options}
			onInputChange={(_, newValue) => {
				setInputValue(newValue);
			}}
			renderInput={(params) => (
				<TextField {...params} fullWidth />
			)}
			getOptionLabel={(option) => option.title}
			onChange={(e, changedValue) => {
				if (props.onChange) {
					props.onChange(changedValue);
				}
			}}
		/>
		{props.value && <div dangerouslySetInnerHTML={{__html: props.value.body}}/>}
		<Button onClick={() => {
			setOpen(true);
		}}>Create</Button>
		<StrapiEmbedPopup open={open} onClose={(v) => {
			setOpen(false);
			props.onChange(v);
		}}/>
	</>
}

export default StrapiEmbed;